// extracted by mini-css-extract-plugin
export default {"controllerContainer":"DomainControllers_controllerContainer__T6kzi","domainsContainer":"DomainControllers_domainsContainer__2ZD0U"};